import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import authActions from "../../redux/auth/actions";
// import pnbLogo from "../../assets/images/pnblogo.jpeg";
import bellIcon from "../../assets/icons/icon.svg";
import { IoNotifications } from "react-icons/io5"
import "./header.scss";
import {
  Dropdown,
  Tooltip,
  Input,
  Form,
  Button,
  Modal,
  message,
  ConfigProvider,
  Select,
  Popover,
} from "antd";
import Cookies from "js-cookie";
// import orgPng from "../../assets/images/org.png";
import mailpng from "../../assets/images/mail (1).png";
import resetPasswordpng from "../../assets/images/reset-password (1).png";
import logoutpng from "../../assets/images/log-out.png";
import { PASSWORD_VALIDATE } from "../../Helpers/Constane";
import { CloseCircleOutlined } from "@ant-design/icons";
import actions from '../../redux/notifications/actions'
import CSCLogo from "../../assets/images/csc_logo.png";
import moment from "moment";


function Header() {
  const { getProfile, changePassword, authReset, getAgentData, selectAgentRequest } = authActions;
  const dispatch = useDispatch();
  const bankLogo = process.env.REACT_APP_IDFC_LOGO;
  const [notifications, setNotifications] = useState([])
  const [viewedNotifications, setViewedNotifications] = useState([])
  const notificationsList = useSelector(state => state.notifications.list);
  const readNotifications = useSelector(state => state.notifications.read);
  const [notificationOpen, setNotificationOpen] = useState(false);
  const [transactionReportFile, setTransactionReportFile] = useState([]);

  const unreadNotifications = notificationsList.filter(
    (msg) => !readNotifications.includes(msg)
  );

  const data = []

  useEffect(() => {
    if (notificationsList.length > 0) {
      setNotificationOpen(true); // Open popover when new notification comes
    }
  }, [notificationsList]);

  // useEffect(() => {
  //   if (viewedNotifications?.length > 0) {
  //     setNotifications(data?.filter((i) => !viewedNotifications?.includes(i)))
  //   } else {
  //     setNotifications(data)
  //   }
  // }, [viewedNotifications])

  // useEffect(() => {
  //   // Optional: reset viewedNotifications if new items come
  //   const newItems = notificationsList.filter(
  //     (msg) => !readNotifications.includes(msg)
  //   );
  //   setNotifications(newItems);
  // }, [notificationsList, readNotifications]);


  const pollTransactionReportData = async () => {
    const pollUrl = `${process.env.REACT_APP_RECON_API_BASE_URL
      }api/cou-dashboard/transactions/poll-data`;
    console.log(pollUrl);
    const fetchData = await fetch(pollUrl, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("biller_access")}`,
      },
    })
    const json = await fetchData.json();
    console.log(json, "polling");
    setTransactionReportFile([...json?.data].reverse() || []);
  }

  useEffect(() => {
    const interval = setInterval(() => {
      pollTransactionReportData()
    }, 50000); // Poll every 5 minutes
    // Clear interval on component unmount
    return () => clearInterval(interval);
  }, []);


  const [messageApi, contextHolder] = message.useMessage();
  const profileData = useSelector((state) => state.authReducer.profileData);
  const { changePasswordMessage, changePasswordError, totalAgent } = useSelector(
    (state) => ({
      changePasswordMessage: state.authReducer.changePasswordMessage,
      changePasswordError: state.authReducer.changePasswordError,
      totalAgent: state.authReducer.totalAgent,
    })
  );

  // console.log("totalllagent", totalAgent)


  // console.log(totalAgent?.organizations?.map((agent,index) => (agent.companyName)) , "totalAgent")

  const buttonLoading = useSelector((state) => state.authReducer.buttonLoading);
  const [open, setOpen] = useState(false);
  const [passwordFormate, setPasswordFormate] = useState(true);
  const handleLogOut = () => {
    sessionStorage.removeItem("biller_access");
    localStorage.removeItem("module_access");
    window.location.href = "/login";
    setOpen(false);
  };
  const handleCancel = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (changePasswordMessage !== null && changePasswordMessage !== undefined) {
      success(changePasswordMessage);
    }
    if (changePasswordError !== null && changePasswordError !== undefined) {
      errorHandle(changePasswordError);
    }
    // eslint-disable-next-line
  }, [changePasswordMessage, changePasswordError]);

  const success = (text) => {
    setOpen(false);
    const hide = messageApi.open({
      type: "success",
      content: text,
    });
    setTimeout(hide, 4000);
    dispatch(authReset());
  };

  const errorHandle = (text) => {
    const hide = messageApi.open({
      type: "error",
      content: text,
    });
    setTimeout(hide, 4000);
    dispatch(authReset());
  };

  const handleOpenPasswordFormModal = () => {
    setOpen(true);
  };

  const handlePassword = (e) => {
    e.preventDefault();
    if (PASSWORD_VALIDATE.test(e.target.value) || e.target.value === "") {
      setPasswordFormate(true);
    } else {
      setPasswordFormate(false);
    }
  };

  // const notificationData = (
  //   <>
  //     {notificationsList.filter((i) => !viewedNotifications?.includes(i))?.length > 0 ? (
  //       <div className="notificationsData">
  //         {notificationsList
  //           ?.map((i, index) => (
  //             <div
  //             className="notification-item"
  //               key={index}
  //             >
  //               <span>
  //                 {i}
  //               </span>
  //               <CloseCircleOutlined
  //                 onClick={() => {
  //                   dispatch(actions.markAsRead(i))
  //                   if (!viewedNotifications?.includes(i)) {
  //                     setViewedNotifications((prevViewedNotifications) => [...prevViewedNotifications, i]);
  //                   }
  //                 }}
  //               />
  //             </div>
  //           ))}
  //       </div>
  //     ) : (
  //       <span className="notificationsData">No New Notification</span>
  //     )}
  //   </>
  // );

  const notificationData = (
    <>
      {unreadNotifications.length > 0 ? (
        <div className="notificationsData scrollable-notifications">
          {unreadNotifications.map((i, index) => (
            <div className="notification-item" key={index}>
              {typeof i === 'string' ? (
                <span>{i}</span>
              ) : i.type === 'download' ? (
                <span>
                  {i.message} &nbsp;
                  <a href={i.url} download target="_blank" rel="noopener noreferrer">
                    Click here
                  </a>
                </span>
              ) : (
                <span>{i}</span>
              )}
              <CloseCircleOutlined
                onClick={() => {
                  dispatch(actions.markAsRead(i));
                }}
              />
            </div>
          ))}
        </div>
      ) : (
        <>
          <>
            {transactionReportFile?.length > 0 && <div>
              {transactionReportFile?.map((item, index) => (
                <div className="notification-item" key={index}>
                  <span style={{ padding: "0px 10px" }}>
                    Transaction Report Created At - {moment(item?.updatedAt).format("DD MMMM YYYY")} {moment(item?.updatedAt).format("hh:mm:ss A")}.
                    &nbsp;
                    <a href={item?.downloadUrl} download target="_blank" rel="noopener noreferrer">
                      Click here
                    </a>
                  </span>
                  <CloseCircleOutlined
                    onClick={() => {
                      dispatch(actions.markAsRead(item));
                    }}
                  />
                </div>
              ))}
            </div>}
          </>
          <span className="notificationsData">No New Notification</span>
        </>
      )}
    </>
  );
  const items = [
    {
      key: 1,
      label: (
        <div className="profileWrapper">
          <div className="profile">
            <div className="circle" style={{ cursor: "pointer" }}>
              <p className="circle-inner-profile">
                {profileData ? profileData?.name?.charAt(0).toUpperCase() : ""}
              </p>
            </div>
            <h3 className="name-profile">{profileData?.name}</h3>
            <p className="title">{profileData?.role}</p>
          </div>
          <div className="email-content">
            <span>
              <img src={mailpng} alt="" width="19" height="19" />
            </span>
            <span className="gmail-p">
              {" "}
              <a href={`mailto:${profileData?.email}`}>{profileData?.email}</a>
            </span>
          </div>
          {/* <div className="email-content">
            <span>
              <img src={orgPng} alt="" width="19" height="19" />
            </span>
            <span className="gmail-p">
              <span>{profileData?.org_id}</span>
            </span>
          </div> */}

          <div className="social-icons">
            <div
              className="email-content"
              onClick={handleOpenPasswordFormModal}
            >
              <span>
                <img src={resetPasswordpng} alt="" width="19" height="19" />
              </span>
              <span className="gmail-p"> Change Password</span>
            </div>

            <div className="email-content" onClick={handleLogOut}>
              <span>
                <img src={logoutpng} alt="" width="19" height="19" />
              </span>
              <span className="gmail-p"> Log Out</span>
            </div>
          </div>
        </div>
      ),
    },
  ];

  const handleSubmit = (values) => {
    dispatch(changePassword(values));
  };
  const handleChange = (agentId) => {
    dispatch(selectAgentRequest(agentId))
  }
  useEffect(() => {
    // debugger
    dispatch(getProfile());
    dispatch(getAgentData(0, 10))
  }, []);




  return (
    <div className="AppHeader">
      {contextHolder}
      <div>
        <img className="logoIcon" src={CSCLogo} alt="Bank logo"></img>
      </div>
      <div className="alignNotification">
        <Popover
          content={notificationData}
          title={`Notifications (${unreadNotifications?.filter((i) => !readNotifications?.includes(i))?.length})`}
          trigger={'click'}
          open={notificationOpen}
          onOpenChange={(open) => setNotificationOpen(open)}
        >
          <div style={{ position: 'relative', cursor: 'pointer', color: 'black' }}>
            {notificationsList && notificationsList?.length > 0 ? (
              <img className="imgIcon" src={bellIcon} alt="notification" />
            ) : (
              <IoNotifications size={25} />
            )}

            {/* Notification badge */}
            {unreadNotifications?.filter((i) => !readNotifications?.includes(i))?.length > 0 && (
              <span className="notification-count">
                {unreadNotifications?.filter((i) => !readNotifications?.includes(i))?.length}
              </span>
            )}

            {transactionReportFile?.length > 0 && (
              <span className="notification-count">
                {transactionReportFile?.length}
              </span>
            )}
          </div>
        </Popover>

        <Dropdown menu={{ items }} placement="topRight" trigger={["click"]}>
          <div className="circle" style={{ cursor: "pointer" }}>
            <p className="circle-inner mb-0">
              {profileData ? profileData?.name?.charAt(0).toUpperCase() : ""}
            </p>
          </div>
        </Dropdown>
      </div>

      <Modal
        title="Change Password"
        open={open}
        onOk={handleCancel}
        onCancel={handleCancel}
        closable={true}
        destroyOnClose={true}
        maskClosable={false}
        centered
        footer={[
          <Button key="back" onClick={handleCancel}>
            CANCEL
          </Button>,
          <Button
            form="passwordForm"
            key="submit"
            htmlType="submit"
            type="primary"
            loading={buttonLoading}
          >
            UPDATE
          </Button>,
        ]}
      >
        <Form
          id="passwordForm"
          onFinish={handleSubmit}
          layout="vertical"
          className="row-col"
        >
          <ConfigProvider>
            <Tooltip
              placement="bottom"
              title={
                "Password must be at least 8 characters, including at least one uppercase (A), one lowercase (a), one special character (#), and digits (12345)."
              }
            >
              <Form.Item
                className="username"
                label="New Password"
                name="password"
                rules={[
                  { required: true, message: "New password is required!" },
                  {
                    validator(_, value) {
                      if (passwordFormate === true) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error("Invalid password format!")
                      );
                    },
                  },
                ]}
              >
                <Input.Password
                  placeholder="New Password"
                  name="password"
                  hasFeedback
                  onChange={handlePassword}
                />
              </Form.Item>
            </Tooltip>
          </ConfigProvider>

          <Form.Item
            className="username"
            label="Confirm Password"
            name="confirmPassword"
            hasFeedback
            rules={[
              { required: true, message: "Confirm password is required!" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error("Confirm password does not match!")
                  );
                },
              }),
            ]}
          >
            <Input.Password
              placeholder="Confirm Password"
              name="confirmPassword"
              onChange={handlePassword}
            />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}

export default Header;
